import styled from 'styled-components';

import { AuthBackgroundImg } from 'assets/img';

export const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;

  background-image: url(${AuthBackgroundImg});
  background-size: auto;
  background-position: top center;
  background-repeat: no-repeat;

  @media (min-width: 2561px), (min-height: 1441px) {
    background-size: cover;
  }
`;
